import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Check } from "lucide-react";

export default function OrderConfirmationPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then(({ data }) => setOrder(data)).catch(() => {});
  }, [orderId]);

  if (!order) return <div className="max-w-[900px] mx-auto px-6 py-32 font-display text-3xl text-[var(--gu-muted)]">Looking for your order…</div>;

  return (
    <div data-testid="order-confirmation-page" className="max-w-[900px] mx-auto px-6 lg:px-12 pt-16 pb-24">
      <div className="w-14 h-14 border border-[var(--gu-primary)] flex items-center justify-center mb-8">
        <Check size={20} strokeWidth={1.5} />
      </div>
      <div className="overline text-[var(--gu-muted)] mb-4">Order confirmed · Mock</div>
      <h1 className="font-display text-5xl lg:text-6xl font-light tracking-tighter">Your plants are packing.</h1>
      <p className="mt-6 text-[var(--gu-muted)] max-w-lg">
        A confirmation would arrive at <span className="text-[var(--gu-primary)]">{order.email}</span> in production.
        Order reference <span data-testid="order-id" className="text-[var(--gu-primary)]">{order.id}</span>.
      </p>

      <div className="mt-16 border-t border-[var(--gu-border)] pt-8 space-y-4">
        {order.items.map((i) => (
          <div key={i.plant_id} className="flex justify-between text-sm">
            <span>{i.plant_name} × {i.quantity}</span>
            <span>${i.line_total.toFixed(2)}</span>
          </div>
        ))}
      </div>
      <div className="mt-8 border-t border-[var(--gu-border)] pt-6 space-y-2 text-sm">
        <Row label="Subtotal" value={`$${order.subtotal.toFixed(2)}`} />
        <Row label="Shipping" value={order.shipping === 0 ? "Free" : `$${order.shipping.toFixed(2)}`} />
        <Row label="Tax" value={`$${order.tax.toFixed(2)}`} />
      </div>
      <div className="mt-4 border-t border-[var(--gu-border)] pt-4 flex justify-between font-display text-2xl">
        <span>Total</span><span>${order.total.toFixed(2)}</span>
      </div>

      <Link to="/shop" className="mt-16 inline-block overline border-b border-[var(--gu-primary)] pb-1">Keep browsing →</Link>
    </div>
  );
}

function Row({ label, value }) {
  return (<div className="flex justify-between text-[var(--gu-muted)]"><span>{label}</span><span className="text-[var(--gu-primary)]">{value}</span></div>);
}
